import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CalendarIcon,
  NewEntriesArrow,
  RightArrow,
  TrendingDown,
  TrendingUp,
} from "../../../../images/icons/icons";
import { fetchDailyLeadMovementStatsData } from "../../../../redux/prospect-reducers/prospectSlice";
import ReactVortoxSpinner from "../../../common-components/ReactVortoxSpinner";
import PipelineFlowDiagram from "./PipelineFlowDiagram";
import { convertStraight } from "../../../common-data/Converts";


const DailyMovementReconciliation = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { dailyLeadMovementStats, dailyLeadMovementStatsLoading } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  // Filters state
  const initialFilters = {
    gym_id: !isAdmin && !isMarketing && !isClusterManager ? userInfoData?.gym_id || "" : "",
  };
  const [filters, setFilters] = useState(initialFilters);

  // // Keep filters in sync with gym_id
  // useEffect(() => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     gym_id: userInfoData?.gym_id || "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    if (!userInfoData?.token) return;
    dispatch(
      fetchDailyLeadMovementStatsData({
        filters,
        token: userInfoData?.token,
      })
    );
  }, [dispatch, userInfoData?.token, filters]);


  const [activeTab, setActiveTab] = useState("daily-movement");
  const [activeDayTabs, setActiveDayTabs] = useState({});

  const tabs = [
    { id: "daily-movement", label: "Daily Movement" },
    // { id: "timeline", label: "Timeline View" },
    // { id: "flow-diagram", label: "Flow Diagram" },
  ];

  const dayTabs = [
    { id: "summary", label: "Summary" },
    { id: "closed-won", label: "Closed Won" },
    { id: "moved-out", label: "Moved Out" },
    { id: "new-entries", label: "New Entries" },
  ];

  // Mock API data - this would come from your API
  const timelineData = [
    {
      id: "day-1",
      date: "Monday 29 January, 2024",
      opening: { leads: 28, value: "₹84,000" },
      closing: { leads: 27, value: "₹81,100" },
      summary: { closedWon: 2, movedOut: 2, newEntries: 3 },
      closedWon: [
        {
          name: "Raj Patel",
          type: "Fresh",
          agent: "Sarah",
          value: "₹1,500",
          time: "10:30 AM",
        },
        {
          name: "Priya Singh",
          type: "Renewal",
          agent: "Mike",
          value: "₹2,400",
          time: "2:15 PM",
        },
      ],
      movedOut: [
        {
          name: "Amit Kumar",
          type: "Fresh",
          agent: "Lisa",
          value: "₹1,200",
          time: "11:45 AM",
          reason: "Lost - Budget constraints",
        },
        {
          name: "Sneha Gupta",
          type: "Expired",
          agent: "Sarah",
          value: "₹1,800",
          time: "4:20 PM",
          reason: "Fake closure detected",
        },
      ],
      newEntries: [
        {
          name: "Vikram Shah",
          type: "Fresh",
          agent: "Mike",
          value: "₹1,600",
          time: "9:15 AM",
        },
        {
          name: "Rohit Mehta",
          type: "Fresh",
          agent: "Sarah",
          value: "₹1,300",
          time: "3:45 PM",
        },
        {
          name: "Anita Reddy",
          type: "Renewal",
          agent: "Lisa",
          value: "₹2,000",
          time: "1:30 PM",
        },
      ],
    },
    {
      id: "day-2",
      date: "Sunday 28 January, 2024",
      opening: { leads: 25, value: "₹75,600" },
      closing: { leads: 28, value: "₹84,000" },
      summary: { closedWon: 1, movedOut: 1, newEntries: 4 },
      closedWon: [
        {
          name: "John Smith",
          type: "Fresh",
          agent: "Emma",
          value: "₹2,200",
          time: "11:20 AM",
        },
      ],
      movedOut: [
        {
          name: "Maria Garcia",
          type: "Renewal",
          agent: "David",
          value: "₹1,400",
          time: "3:10 PM",
          reason: "Lost - No response",
        },
      ],
      newEntries: [
        {
          name: "Alex Johnson",
          type: "Fresh",
          agent: "Emma",
          value: "₹1,800",
          time: "10:00 AM",
        },
        {
          name: "Lisa Chen",
          type: "Fresh",
          agent: "David",
          value: "₹2,100",
          time: "2:30 PM",
        },
        {
          name: "Tom Wilson",
          type: "Renewal",
          agent: "Emma",
          value: "₹2,500",
          time: "4:45 PM",
        },
        {
          name: "Sarah Brown",
          type: "Fresh",
          agent: "David",
          value: "₹1,300",
          time: "1:15 PM",
        },
      ],
    },
    // Example of how to add more days dynamically
    {
      id: "day-3",
      date: "Saturday 27 January, 2024",
      opening: { leads: 22, value: "₹66,000" },
      closing: { leads: 25, value: "₹75,600" },
      summary: { closedWon: 3, movedOut: 0, newEntries: 6 },
      closedWon: [
        {
          name: "Michael Brown",
          type: "Fresh",
          agent: "Sarah",
          value: "₹1,900",
          time: "9:30 AM",
        },
        {
          name: "Emily Davis",
          type: "Renewal",
          agent: "Mike",
          value: "₹2,600",
          time: "1:45 PM",
        },
        {
          name: "James Wilson",
          type: "Fresh",
          agent: "Lisa",
          value: "₹1,700",
          time: "3:20 PM",
        },
      ],
      movedOut: [],
      newEntries: [
        {
          name: "Sophie Turner",
          type: "Fresh",
          agent: "Emma",
          value: "₹2,300",
          time: "10:15 AM",
        },
        {
          name: "Robert Johnson",
          type: "Renewal",
          agent: "David",
          value: "₹2,800",
          time: "11:30 AM",
        },
        {
          name: "Jennifer Lee",
          type: "Fresh",
          agent: "Sarah",
          value: "₹1,400",
          time: "2:00 PM",
        },
        {
          name: "Christopher Kim",
          type: "Fresh",
          agent: "Mike",
          value: "₹1,900",
          time: "3:45 PM",
        },
        {
          name: "Amanda White",
          type: "Renewal",
          agent: "Lisa",
          value: "₹2,200",
          time: "4:30 PM",
        },
        {
          name: "Daniel Martinez",
          type: "Fresh",
          agent: "Emma",
          value: "₹1,600",
          time: "5:15 PM",
        },
      ],
    },
  ];

  // Initialize active tabs for each day
  useEffect(() => {
    const initialTabs = {};
    timelineData.forEach((day) => {
      initialTabs[day.id] = "summary";
    });
    setActiveDayTabs(initialTabs);
  }, []);

  const getActiveTab = (dayId) => {
    return activeDayTabs[dayId] || "summary";
  };

  // Helper function to set active tab for a specific day
  const setActiveTabForDay = (dayId, tabId) => {
    setActiveDayTabs((prev) => ({
      ...prev,
      [dayId]: tabId,
    }));
  };

  // Helper function to get tab label with count
  const getTabLabel = (tab, dayData) => {
    switch (tab.id) {
      case "closed-won":
        return `Closed Won (${dayData.summary.closedWon})`;
      case "moved-out":
        return `Moved Out (${dayData.summary.movedOut})`;
      case "new-entries":
        return `New Entries (${dayData.summary.newEntries})`;
      default:
        return tab.label;
    }
  };

  // Transform API data to component format
  const dailyMovement =
    (dailyLeadMovementStats?.data || [])?.map((item) => ({
      date: item?.date,
      movements: [
        {
          type: "into",
          stage: "Closure Expected",
          count: parseInt(item?.closure_expected_count) || 0,
          value: item?.closure_expected_value,
        },
        {
          type: "out",
          stage: "Closure Expected → Closed Won",
          count: parseInt(item?.moved_to_closed_won_count) || 0,
          value: item?.moved_to_closed_won_value,
        },
        {
          type: "lost",
          stage: "Lost from Closure Expected",
          count: parseInt(item?.moved_to_lost_count) || 0,
          value: item?.moved_to_lost_value,
        },
      ],
    })) || [];

  const getMovementClass = (type) => {
    switch (type) {
      case "into":
        return "movement-into";
      case "out":
        return "movement-out";
      case "lost":
        return "movement-lost";
      default:
        return "";
    }
  };

  const getStatusBadgeClass = (type) => {
    switch (type) {
      case "Fresh":
        return "lms-closure-pipeline-tracker-status-badge fresh";
      case "Renewal":
        return "lms-closure-pipeline-tracker-status-badge renewal";
      case "Expired":
        return "lms-closure-pipeline-tracker-status-badge expired";
      default:
        return "lms-closure-pipeline-tracker-status-badge";
    }
  };

  // Render entry cards for any category
  const renderEntryCards = (entries, cardType) => {
    return (
      <div className="lms-closure-pipeline-tracker-entry-cards">
        {entries.map((entry, index) => (
          <div
            key={index}
            className={`lms-closure-pipeline-tracker-entry-card ${cardType}-card`}
          >
            <div
              className={{ display: "flex", flexDirection: "col", gap: "4px" }}
            >
              <div className="lms-closure-pipeline-tracker-card-header">
                <span className={getStatusBadgeClass(entry.type)}>
                  {entry.type}
                </span>
                <span className="lms-closure-pipeline-tracker-entry-name">
                  {entry.name}
                </span>
              </div>
              <div className="lms-closure-pipeline-tracker-card-body">
                <div className="lms-closure-pipeline-tracker-assigned-person">
                  <span className="lms-closure-pipeline-tracker-person-icon">
                    👤
                  </span>
                  <span>{entry.agent}</span>
                </div>
                {entry.reason && (
                  <div className="lms-closure-pipeline-tracker-alert-message">
                    <span className="lms-closure-pipeline-tracker-warning-icon">
                      ⚠️
                    </span>
                    <span className="lms-closure-pipeline-tracker-alert-text">
                      {entry.reason}
                    </span>
                  </div>
                )}
                <div className="lms-closure-pipeline-tracker-action-status">
                  <span className="lms-closure-pipeline-tracker-arrow-icon">
                    →
                  </span>
                  <span>
                    {cardType === "closed-won"
                      ? "Closed Won"
                      : cardType === "moved-out"
                      ? entry.reason
                        ? "Lost"
                        : "Moved Out"
                      : "Visit Done"}
                  </span>
                </div>
              </div>
            </div>
            <div className="lms-closure-pipeline-tracker-card-footer">
              <div className="lms-closure-pipeline-tracker-entry-value">
                {entry.value}
              </div>
              <div className="lms-closure-pipeline-tracker-entry-time">
                <span className="lms-closure-pipeline-tracker-calendar-icon">
                  <CalendarIcon />
                </span>
                <span>{entry.time}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Render day content based on active tab
  const renderDayContent = (dayData, activeTab) => {
    switch (activeTab) {
      case "summary":
        return (
          <>
            <div className="lms-closure-pipeline-tracker-day-card closed-won">
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div className="lms-closure-pipeline-tracker-day-card-trendingup-icon">
                  <TrendingUp className="card-icon" />
                </div>
                <div className="card-label">Closed Won</div>
              </div>
              <div className="card-number">{dayData.summary.closedWon}</div>
              <div className="card-value">
                ₹{dayData.summary.closedWon * 1950}
              </div>
            </div>
            <div className="lms-closure-pipeline-tracker-day-card moved-out">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <div className="lms-closure-pipeline-tracker-day-card-trendingdown-icon">
                  <TrendingDown className="card-icon" />
                </div>
                <div className="card-label">Moved Out</div>
              </div>
              <div className="card-number">{dayData.summary.movedOut}</div>
              <div className="card-value">
                ₹{dayData.summary.movedOut * 1500}
              </div>
            </div>
            <div className="lms-closure-pipeline-tracker-day-card new-entries">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "8px",
                  alignItems: "center",
                }}
              >
                <NewEntriesArrow className="card-icon" />
                <div className="card-label">New Entries</div>
              </div>
              <div className="card-number">{dayData.summary.newEntries}</div>
              <div className="card-value">
                ₹{dayData.summary.newEntries * 1750}
              </div>
            </div>
          </>
        );
      case "closed-won":
        return (
          <div className="day-content">
            {renderEntryCards(dayData.closedWon, "closed-won")}
          </div>
        );
      case "moved-out":
        return (
          <div className="day-content">
            {renderEntryCards(dayData.movedOut, "moved-out")}
          </div>
        );
      case "new-entries":
        return (
          <div className="day-content">
            <div className="lms-closure-pipeline-tracker-entry-cards new-entries-layout">
              {dayData.newEntries.map((entry, index) => (
                <div
                  key={index}
                  className="lms-closure-pipeline-tracker-entry-card new-entry-card"
                >
                  <div
                    className={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div className="lms-closure-pipeline-tracker-card-header">
                      <span className={getStatusBadgeClass(entry.type)}>
                        {entry.type}
                      </span>
                      <span className="lms-closure-pipeline-tracker-entry-name">
                        {entry.name}
                      </span>
                    </div>
                    <div className="lms-closure-pipeline-tracker-card-body">
                      <div className="lms-closure-pipeline-tracker-assigned-person">
                        <span className="lms-closure-pipeline-tracker-person-icon">
                          👤
                        </span>
                        <span>{entry.agent}</span>
                      </div>
                      <div className="lms-closure-pipeline-tracker-action-status">
                        <span className="lms-closure-pipeline-tracker-arrow-icon">
                          →
                        </span>
                        <span>Visit Done</span>
                      </div>
                    </div>
                  </div>
                  <div className="lms-closure-pipeline-tracker-card-footer">
                    <div className="lms-closure-pipeline-tracker-entry-value">
                      {entry.value}
                    </div>
                    <div className="lms-closure-pipeline-tracker-entry-time">
                      <CalendarIcon></CalendarIcon>
                      <span>{entry.time}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="lms-closure-pipeline-tracker-daily-movement-reconciliation">
      {/* Tabs */}
      <div className="lms-closure-pipeline-tracker-reconciliation-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`lms-closure-pipeline-tracker-reconciliation-tab ${
              activeTab === tab.id ? "active" : ""
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="reconciliation-content">
        {activeTab === "daily-movement" && (
          <div className="lms-closure-pipeline-tracker-daily-movement-view">
            <div className="lms-closure-pipeline-tracker-reconciliation-header">
              <div className="lms-closure-pipeline-tracker-reconciliation-title-section">
                <h3 className="lms-closure-pipeline-tracker-reconciliation-title">
                  Daily Movement Reconciliation
                </h3>
                <p className="lms-closure-pipeline-tracker-reconciliation-subtitle">
                  Track lead movements in and out of each stage for daily
                  reconciliation
                </p>
              </div>
            </div>
            {dailyLeadMovementStatsLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: 200,
                }}
              >
                <ReactVortoxSpinner />
              </div>
            ) : (
              dailyMovement.map((day, index) => (
                <div
                  key={index}
                  className="lms-closure-pipeline-tracker-movement-day"
                >
                  <div className="lms-closure-pipeline-tracker-daily-movement-day-header">
                    <h4 className="lms-closure-pipeline-tracker-day-title">
                      {convertStraight(day.date)}
                    </h4>
                  </div>
                  <div className="lms-closure-pipeline-tracker-movement-cards">
                    {day.movements.map((movement, movIndex) => (
                      <div
                        key={movIndex}
                        className={`lms-closure-pipeline-tracker-movement-card ${getMovementClass(
                          movement.type
                        )}`}
                      >
                        <h5 className="lms-closure-pipeline-tracker-movement-stage">
                          {movement.stage}
                        </h5>
                        <div className="lms-closure-pipeline-tracker-movement-count">
                          {movement.count} leads
                        </div>
                        <div className="lms-closure-pipeline-tracker-movement-value">
                        ₹ {movement.value}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))
            )}
            {/* No local pagination bar in this component */}
          </div>
        )}

        {activeTab === "timeline" && (
          <div className="lms-closure-pipeline-tracker-timeline-view">
            <div className="lms-closure-pipeline-tracker-timeline-header">
              <div className="lms-closure-pipeline-tracker-timeline-title-section">
                <h3 className="lms-closure-pipeline-tracker-timeline-title">
                  Timeline View
                </h3>
                <p className="lms-closure-pipeline-tracker-timeline-subtitle">
                  Day-by-day breakdown of closure expected movements
                </p>
              </div>
              <button className="lms-closure-pipeline-tracker-btn-export-timeline">
                Export Timeline
              </button>
            </div>

            <div className="lms-closure-pipeline-tracker-timeline-days">
              {timelineData.map((day, index) => (
                <div
                  key={day.id}
                  className="lms-closure-pipeline-tracker-timeline-day"
                >
                  <div className="lms-closure-pipeline-tracker-day-header">
                    <h4 className="lms-closure-pipeline-tracker-day-date">
                      {day.date}
                    </h4>
                    <div className="lms-closure-pipeline-tracker-day-summary">
                      <div className="opening-section">
                        {day.opening.leads} leads • {day.opening.value}
                      </div>
                      <RightArrow></RightArrow>
                      <div className="closing-section">
                        {day.closing.leads} leads • {day.closing.value}
                      </div>
                    </div>
                  </div>

                  <div className="lms-closure-pipeline-tracker-day-tabs">
                    {dayTabs.map((tab) => (
                      <button
                        key={tab.id}
                        className={`lms-closure-pipeline-tracker-day-tab ${
                          getActiveTab(day.id) === tab.id ? "active" : ""
                        }`}
                        onClick={() => setActiveTabForDay(day.id, tab.id)}
                      >
                        {getTabLabel(tab, day)}
                      </button>
                    ))}
                  </div>

                  <div className="lms-closure-pipeline-tracker-day-cards">
                    {renderDayContent(day, getActiveTab(day.id))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "flow-diagram" && (
          <div className="flow-diagram-view">
            <PipelineFlowDiagram />
          </div>
        )}
      </div>
    </div>
  );
};

export default DailyMovementReconciliation;
